import type { ShapeKind } from "./types";

export const DAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const MINOR = 20;
export const MAJOR = 100;
export const MIN_SCALE = 0.3;
export const MAX_SCALE = 2.5;
export const CANVAS_W = 8000;
export const CANVAS_H = 5000;
export const CANVAS_EDGE_MARGIN = 100;

export function clampVp(v: { x: number; y: number; scale: number }): { x: number; y: number; scale: number } {
  const W = window.innerWidth;
  const H = window.innerHeight;
  return {
    ...v,
    x: Math.max(CANVAS_EDGE_MARGIN - CANVAS_W * v.scale, Math.min(W - CANVAS_EDGE_MARGIN, v.x)),
    y: Math.max(CANVAS_EDGE_MARGIN - CANVAS_H * v.scale, Math.min(H - CANVAS_EDGE_MARGIN, v.y)),
  };
}

export const NOTE_W = 200;
export const NOTE_HEADER_H = 30;
export const NOTE_BODY_H = 180;
export const STICKER_SIZE = 120;
export const SECTION_PART_W = 300;
export const SECTION_H = 320;
export const SECTION_PARTS = 3;
export const SECTION_TITLE_H = 32;

export const NOTE_COLORS = [
  { header: "#fbbf24", body: "#fef9c3" },
  { header: "#fb923c", body: "#ffedd5" },
  { header: "#f87171", body: "#fee2e2" },
  { header: "#f472b6", body: "#fce7f3" },
  { header: "#a78bfa", body: "#ede9fe" },
  { header: "#60a5fa", body: "#dbeafe" },
  { header: "#34d399", body: "#d1fae5" },
  { header: "#2dd4bf", body: "#ccfbf1" },
];

export function getNoteColors(bodyColor: string) {
  return NOTE_COLORS.find((c) => c.body === bodyColor) ?? NOTE_COLORS[0];
}

export const SHAPE_COLORS = [
  "#60a5fa",
  "#34d399",
  "#fbbf24",
  "#fb923c",
  "#f87171",
  "#f472b6",
  "#a78bfa",
  "#94a3b8",
];

export const SHAPE_DEFAULT_COLOR = SHAPE_COLORS[0];

export const SHAPE_KINDS: ShapeKind[] = ["rectangle", "square", "circle", "triangle"];

export function shapeDefaultSize(kind: ShapeKind): { w: number; h: number } {
  switch (kind) {
    case "rectangle":
      return { w: 180, h: 110 };
    case "square":
      return { w: 130, h: 130 };
    case "circle":
      return { w: 130, h: 130 };
    case "triangle":
      return { w: 150, h: 130 };
  }
}
